export const SIDEBAR_WIDTH = '200px';

export const MAIN_STYLE = {
  backgroundColor: '#F7F7F7',
};

export const FOOTER_STYLE = MAIN_STYLE;
